import { createApiActionType } from 'app/store/utils';

const apiType = createApiActionType('glossary');

export const LOAD_GLOSSARY = apiType('LoadGlossary');
export const CREATE_CATEGORY = apiType('CreateCategory');
export const DELETE_CATEGORY = apiType('DeleteCategory');
export const RENAME_CATEGORY = apiType('RenameCategory');

export const CREATE_GLOSSARY_TERM = apiType('CreateGlossaryTerm');
export const UPDATE_GLOSSARY_TERM = apiType('UpdateGlossaryTerm');
export const DELETE_GLOSSARY_TERM = apiType('DeleteGlossaryTerm');
